import { render, staticRenderFns } from "./TheHeaderDropdownLang.vue?vue&type=template&id=15466ee4&"
import script from "./TheHeaderDropdownLang.vue?vue&type=script&lang=js&"
export * from "./TheHeaderDropdownLang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports